<span class="relative flex flex-col w-full h-full">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'label_add_property' | translate }}</div>
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button (click)="close()" mat-icon-button [matDialogClose]="undefined">
                <mat-icon class="white-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>

    @if (false) {
    <div class="p-6" mat-dialog-content>
        <div class="grid sm:grid-cols-4 gap-6 w-full mt-[220px]">
            <div class="col-span-4">
                <app-loader-inline class="float-left mt-[50px]"></app-loader-inline>
            </div>
        </div>
    </div>
    } @if (true) {
    <form [formGroup]="form" class="mx-8 my-4">
        <div>{{ 'text_add_mortgage_eligibility_property' | translate }}</div>
        <mat-divider class="my-4"></mat-divider>
        @if (form) {
        <div class="grid grid-cols-1 w-full gap-4 margin-top margin-bottom-10">
            <mat-form-field class="fuse-mat-no-subscript basis-full sm:basis-80">
                <mat-label class="font-medium">{{ 'info_search_property' | translate }}</mat-label>
                <input
                    [placeholder]="'info_search_property_placeholder' | translate"
                    matInput
                    formControlName="addressSearch"
                    [matAutocomplete]="auto"
                />
                @if (!loadingAddresses) {
                <mat-icon class="icon-size-5" fontIcon="search" matSuffix></mat-icon>
                } @if (loadingAddresses) {
                <mat-spinner class="overflow-visible" diameter="20"></mat-spinner>
                }
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onPropertySelected($event.option.value)" panelWidth="auto">
                    @for (option of addressSearchResults; track option) {
                    <mat-option [value]="option.value" class="text-[0.9rem]"> {{option.label}} </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
        }
        <div class="mt-4 flex justify-end">
            <button (click)="submit()" mat-flat-button [color]="'primary'" [disabled]="!selectedProperty">
                @if (formEnabled) {
                <span>{{ 'label_confirm' | translate }}</span>
                } @if (!formEnabled) {
                <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                }
            </button>
        </div>
    </form>
    }
</span>
